import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import questionMarkCircleFill from '@iconify/icons-eva/question-mark-circle-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import { MIconButton } from '../../components/@material-extend';
import MyAvatar from '../../components/MyAvatar';
import MenuPopover from '../../components/MenuPopover';
import { Magic } from 'magic-sdk';
import { Image } from '@mui/icons-material';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Marketplace',
    icon: homeFill,
    linkTo: '/'
  },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: PATH_DASHBOARD.user.profile
  },
  {
    label: 'Help',
    icon: questionMarkCircleFill,
    linkTo: PATH_DASHBOARD.user.account
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { user ,logout} = useAuth();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    localStorage.removeItem('satoken')
    localStorage.removeItem('savalidtoken')
      logout()
      history("/")
              }
  

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <MyAvatar/ >
      </MIconButton>
{console.log(user)}
      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user?.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined"
           onClick={handleLogout}>
            Logout
          </Button>
        </Box>
        <Box sx={{ p: 2, pt: 1.5 ,display:'flex',justifyContent: 'center'
        ,flexDirection:'column',alignItems: 'center'}}>
          <Typography variant="subtitle2">Follow Us On</Typography>
          <Box display="flex">
          <img alt="twitter" style={{width:'35px',cursor: 'pointer'}} 
          onClick={()=>window.open("https://twitter.com/SimpleAccounts_","_blank")}
          src="https://img.icons8.com/color/48/000000/twitter--v1.png"/>
          <img alt="facebook" style={{width:'35px',cursor: 'pointer'}} 
          onClick={()=>window.open("https://www.facebook.com/simpleAccounts/","_blank")}
          src="https://img.icons8.com/color/48/000000/facebook-new.png"/>
          <img alt="linkedin" style={{width:'35px',cursor: 'pointer'}}
           onClick={()=>window.open("https://www.linkedin.com/company/simpleaccounts","_blank")}
          src="https://img.icons8.com/color/48/000000/linkedin.png"/>
          </Box>
        </Box>

      </MenuPopover>
    </>
  );
}
